import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../axios/axiosInstance";

export const fetchDashboardStats = createAsyncThunk(
  "dashboardStats/fetch",
  async ({ startDate, endDate } = {}, { rejectWithValue }) => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate)   params.endDate   = endDate;
      const res = await api.get("/dashboard/quick-stats", { params });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to load stats");
    }
  }
);

const dashboardStatsSlice = createSlice({
  name: "dashboardStats",
  initialState: {
    totalLeads: 0,
    totalWabaChats: 0,
    totalMeetings: 0,
    todayMeetings: [],
    todayMeetingsCount: 0,
    loading: true,
    error: null,
  },
  reducers: {
    setStatsLoading: (state) => { state.loading = true; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.totalLeads        = action.payload.totalLeads        ?? 0;
        state.totalWabaChats    = action.payload.totalWabaChats    ?? 0;
        state.totalMeetings     = action.payload.totalMeetings     ?? 0;
        state.todayMeetings     = action.payload.todayMeetings     ?? [];
        state.todayMeetingsCount = action.payload.todayMeetingsCount ?? 0;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setStatsLoading } = dashboardStatsSlice.actions;
export default dashboardStatsSlice.reducer;
